import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import authReducer from "../features/auth/authSlice";
import rememberMeReducer from "../features/auth/rememberMeSlice";
import courseReducer from "../features/auth/courseSlice";
import quizResultReducer from "../features/auth/quizResultSlice";
import getUserInfo from "../features/auth/userSlice";
import getQuestionsList from "../features/auth/playQuestionsListSlice";
import eventDetails from "../features/battle-ground/event/eventSlice";
import modeReducer from "../features/modeSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  rememberMe: rememberMeReducer,
  course: courseReducer,
  quizResult: quizResultReducer,
  getUserInfo: getUserInfo,
  eventDetails: eventDetails,
  getQuestionsList: getQuestionsList,
  themeMode: modeReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});
